import { Box, styled, useTheme } from '@mui/material';
import { PieChart } from '@mui/x-charts';
import { useDrawingArea } from '@mui/x-charts/hooks';
import type { FC } from 'react';

interface AvaniTaintPieChartProps {
  tainted: number;
  noTaint: number;
}

const StyledTitle = styled('text')(({ theme }) => ({
  textAnchor: 'middle',
  dominantBaseline: 'central',
  fontSize: 24
}));

function PieCenterLabel({ tainted, noTaint }: { noTaint: number; tainted: number }) {
  const { width, height, left, top } = useDrawingArea();

  return (
    <g>
      <StyledTitle x={left + width / 2} y={top + height / 2 + 3}>
        {tainted}/{noTaint}
      </StyledTitle>
    </g>
  );
}

export const AvaniTaintPieChart: FC<AvaniTaintPieChartProps> = ({ tainted, noTaint }) => {
  const theme = useTheme();

  const chartColors = [theme.palette.aTurc.main, theme.palette.aTeal.main];

  const chartData: {
    value: number;
    label: string;
  }[] = [
    {
      value: tainted,
      label: 'Tainted'
    }
  ];

  const chartLeftOffset = '-47px';

  return (
    <Box
      sx={{
        padding: 0,
        width: '125px',
        overflow: 'hidden',
        margin: '0 auto'
      }}
    >
      <Box
        sx={{
          padding: 0,
          margin: 0,
          overflow: 'hidden',
          marginLeft: chartLeftOffset
        }}
      >
        <PieChart
          series={[{ data: chartData, innerRadius: 40 }]}
          height={120}
          width={320}
          margin={{
            top: 0,
            left: 0
          }}
          colors={chartColors}
          sx={{
            ['.MuiPieArc-root']: { stroke: 'none' }
          }}
          slotProps={{
            legend: { hidden: true }
          }}
        >
          <PieCenterLabel tainted={tainted} noTaint={noTaint}></PieCenterLabel>
        </PieChart>
      </Box>
    </Box>
  );
};
